import React, {Component} from 'react';
import './ErrorMessage.css';
import PropTypes from 'prop-types';

export default class ErrorMessage extends Component {
    render() {
        return (
            <div className={"ErrorMessage"}>
                <p className={"ErrorMessage__txt"}>{this.props.message}</p>
            </div>
        );
    }
}

ErrorMessage.propTypes = {
    message: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/Common/ErrorMessage.js